<template>
	<div class="full-page-loading" v-if="show">
			<div class="md-layout">
				<div class="md-layout-item">
					<div v-if="!error" style="padding-top:30px;">
						<md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
						<p><span>{{$t('loading')}}</span></p>
					</div>
					<div v-if="error">
						<p>{{$t('encountered-error')}} <a href="javascript:;" v-on:click="refresh">{{$t('refresh-page')}}</a>.</p>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
export default {
	name: `FullPageLoading`,
	props: {
		error: Boolean,
		show: Boolean
	},
	methods: {
		refresh() {
			location.reload()
			return
		}
	}
}
</script>